import script from "./MfaEnrollmentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MfaEnrollmentModal.vue?vue&type=script&setup=true&lang=ts"

import "./MfaEnrollmentModal.vue?vue&type=style&index=0&id=b85a754a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b85a754a"]])

export default __exports__